import { useAtom } from '@reatom/npm-react'
import { AnimatePresence, motion } from 'motion/react'
import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Snackbar } from '@root/shared/ui-kit/snackbar/snackbar'

import { shortcutAppRouter } from '../../app-shortcuts'
import { reatomPossibleShortcutAtom } from '../../atoms/reatom-possible-shortcut'
import { ShortcutCommandShow } from '../shortcut-command-show'

const layoutTransition = {
  layout: { duration: 0.2, ease: 'easeInOut' },
  duration: 0.2,
  ease: 'easeInOut',
} as const

export const PossibleShortcutHint: React.FC = () => {
  const { t } = useTranslation()
  const [possibleShortcutId] = useAtom(reatomPossibleShortcutAtom)

  const route = possibleShortcutId
    ? shortcutAppRouter[possibleShortcutId]
    : undefined

  return (
    <AnimatePresence initial={false}>
      {route ? (
        <HintWrapper
          key={possibleShortcutId}
          layout
          transition={layoutTransition}
          initial={{ scale: 0, opacity: 0.3 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.7, opacity: 0 }}
        >
          <Snackbar
            intent="info"
            description={
              <Description>
                <ShortcutCommandShow commandShow={route.commandShow} />
              </Description>
            }
          >
            {t(route.description)}
          </Snackbar>
        </HintWrapper>
      ) : undefined}
    </AnimatePresence>
  )
}

const HintWrapper = styled(motion.div)`
  overflow: hidden;
`
const Description = styled.div`
  display: grid;
  width: 100%;
  align-items: flex-end;
  font-size: 14px;
`
